<template>
<div>
    <el-dialog
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    :title="textMap[dialogStatus]"
    :visible.sync="dialogFormVisible"
    width="60%"
    @close="clearForm()">
        <el-form
            :inline="true"
            :model="listForm"
            ref="listForm"
            :rules="validateRule"
            label-width="120px"
        >
            <el-row>
            <el-col :span="12">
                <el-form-item label="信息集ID" prop="infoSetId">
                <el-input :disabled="this.dialogStatus=='update'" v-model="listForm.infoSetId" />
                </el-form-item>
            </el-col>

            <el-col :span="12">
                <el-form-item label="信息集中文名称" prop="infoSetName">
                <el-input v-model="listForm.infoSetName" />
                </el-form-item>
            </el-col>

            <el-col :span="12">
                <el-form-item label="信息集英文名称" prop="infoSetEnName">
                <el-input v-model="listForm.infoSetEnName" />
                </el-form-item>
            </el-col>

            <el-col :span="12">
                <el-form-item label="信息集类型" prop="infoSetType">
                <el-select v-model="listForm.infoSetType" placeholder="请选择">
                    <el-option v-for="item in this.dicts.codeList[1032]"
                     :key="item.codeItemId"
                     :value="item.codeItemId"
                     :label="item.codeItemName"
                    ></el-option>
                </el-select>
                </el-form-item>
            </el-col>

            <el-col :span="12">
                <el-form-item label="记录类型" prop="infoSetRstype">
                <el-select v-model="listForm.infoSetRstype" placeholder="请选择">
                    <el-option v-for="item in infoSetRstypeList"
                     :key="item.codeItemId"
                     :value="item.codeItemId"
                     :label="item.codeItemName"
                    ></el-option>
                </el-select>
                </el-form-item>
            </el-col>

            <el-col :span="12">
                <el-form-item label="业务类型" prop="infoSetRstype">
                <el-input v-model="listForm.infoSetRstype" />
                </el-form-item>
            </el-col>

            <el-col :span="12">
                <el-form-item label="排序字段" prop="infoSetOrder">
                <el-input v-model="listForm.infoSetOrder" />
                </el-form-item>
            </el-col>

            <el-col :span="12">
                <el-form-item label="信息项分类(中文)" prop="infoItemGroup">
                <el-input v-model="listForm.infoItemGroup" />
                </el-form-item>
            </el-col>

            <el-col :span="12">
                <el-form-item label="信息项分类(英文)" prop="infoItemEnGroup">
                <el-input v-model="listForm.infoItemEnGroup" />
                </el-form-item>
            </el-col>

            <el-col :span="12">
                <el-form-item label="排序" prop="infoSetSeq">
                <el-input v-model="listForm.infoSetSeq" />
                </el-form-item>
            </el-col>

            <el-col :span="12">
                <el-form-item label="信息集编号" prop="infoSetCode">
                <el-input v-model="listForm.infoSetCode" />
                </el-form-item>
            </el-col>

            <el-col :span="12">
                <el-form-item label="描述" prop="remark">
                <el-input v-model="listForm.remark" />
                </el-form-item>
            </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <el-button type="primary" :disabled="btnUnable" @click="handlerListForm()">保 存</el-button>
            <el-button @click="cancel()">取 消</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {saveInfoSet,checkInfoSetId,editSysInfoSet} from '@/api/sys/info'

export default {
    name: 'SysInfoSetDialog',
    props: {
        dialogStatus:{
            type: String,
            default: ""
        },
        dialogFormVisible: {
            type: Boolean
        },
        listForm:{
            type:Object,
            default: {}
        },
        dicts:{
            type: Object,
            default:[]
        },
        infoSetRstypeList:{
            type: Array,
            default: []
        }
    },
    created() {
    },
    data() {
        let validateInfoSetId = (rule,value,callback) =>{
            let tenantId=this.role.tenantId
            checkInfoSetId(tenantId,value).then(res =>{
                this.isExistInfoSetId=res.data
            })
            if(this.isExistInfoSetId){
                console.log('存在相同的infoSetId')
                callback(new Error('存在相同的infoSetId'))
            }else{
                console.log('infoSetId验证通过')
                callback();
            }
        }
        return {
            isUpdateForm:false,
            //TODO 需要真是用户
            role: {
                name: 'admin',
                tenantId: 'sys'
            },
            isExistInfoSetId: false,
            btnUnable: false,
            textMap: {
                add: "新增信息集",
                update: "编辑信息集"
            },
            validateRule: {
                infoSetId: [
                    { required: true, message: "信息集ID不能为空！", trigger: "blur"},
                    { required: true, trigger: "blur", validator: validateInfoSetId}
                ],
                infoSetName: [
                    { required: true, message: "信息集中文名不能为空！", trigger: "blur"}
                ],
                // infoSetEnName: [
                //     { required: true, message: "信息集英文名不能为空", trigger: "blur"}
                // ],
                infoSetType: [
                    { required: true, message: "信息集类型不能为空", trigger: "blur"}
                ],
                infoSetRstype: [
                    { required: true, message: "业务类型不能为空", trigger: "blur"}
                ],
                infoSetOrder: [
                    { required: true, message: "排序字段不能为空", trigger: "blur"}
                ],
                // infoSetSeq: [
                //     { required: true, message: "排序不能为空", trigger: "blur"}
                // ],
            }
        }
    },

    methods: {
        handlerListForm() {
            console.log('当前dialog状态为：'+this.dialogStatus)
            console.log('当前listForm为：'+ JSON.stringify(this.listForm))
            if (this.dialogStatus === "add") {
            this.addForm();
            } else if (this.dialogStatus === "update") {
            this.updateForm();
            }
        },
        addForm(){
            this.$refs.listForm.validate((valid) => {
                console.log('是否通过验证：'+valid)
                this.btnUnable=true
                if(valid){
                    saveInfoSet(this.listForm).then((res)=>{
                        console.log(JSON.stringify(res))
                        if (res.data.code == 0){
                            this.dialogFormVisible = false;
                            this.btnUnable=false
                            this.$emit('data-refresh');
                            this.$message.success("新增成功！");
                        } else {
                            this.btnUnable=false
                            this.$message.error(res.data.msg);
                        }
                    }).catch(err=>{
                        this.btnUnable=false
                    })
                }else{
                    this.btnUnable=false
                    this.$message.error(res.data.msg);
                }
            })
        },
        updateForm() {
            console.log('当前listForm为：'+JSON.stringify(this.listForm))
            this.btnUnable=true
            this.$refs.listForm.validate((valid) => {
                console.log('是否通过验证：'+valid)
                if (valid){
                    editSysInfoSet(this.listForm).then(res => {
                    if (res.data.code == 0){
                        this.btnUnable=false
                        this.dialogFormVisible = false;
                        this.$emit('data-refresh');
                        this.$message.success("编辑成功！");
                    } else {
                        this.btnUnable=false
                        this.$message.error(res.data.msg);
                    }
                    })
                }else{
                    this.btnUnable=false
                }
            })
        },
        // 关闭后清空dialog
        clearForm(){
        this.$refs.listForm.resetFields()
        this.$refs.listForm.clearValidate()
        this.dialogFormVisible = false
        this.btnUnable=false
        this.$emit('update:dialogFormVisible',false)
        },
        cancel(){
            this.dialogFormVisible = false
            this.$emit('update:dialogFormVisible',false)
        }
    },
}
</script>
